<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    :title="`${$t('新增无关项')}`"
    class="large-dialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div class="flex h-full">
      <div class="w-260px mr-20px">
        <catalog
          class="w-full border-color-default border-1px border-solid p-10px"
          @node-click="handleNodeClick"
          :id="id"
          :status="status"
        />
      </div>
      <div class="h-full flex-1">
        <div class="mb-20px">
          <el-input
            clearable
            v-model="search.project"
            class="w-200px mr-10px"
            size="small"
            :maxlength="50"
            :placeholder="`${$t('评价项目')}`"
          ></el-input>
          <el-button @click="searchList" size="small" type="primary">{{ $t('搜索') }}</el-button>
          <el-button @click="reset" size="small">{{ $t('重置') }}</el-button>
        </div>
        <el-table
          height="calc(100% - 104px)"
          stripe
          border
          :data="tableData"
          row-key="id"
          ref="table"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
            reserve-selection
            :selectable="(row) => !selectedIds.includes(row.id)"
          ></el-table-column>
          <el-table-column prop="chapter" :label="`${$t('序号')}`" width="100"></el-table-column>
          <el-table-column
            prop="project"
            :label="`${$t('评价项目')}`"
            width="120"
          ></el-table-column>
          <el-table-column prop="content" :label="`${$t('评价内容')}`"></el-table-column>
          <el-table-column
            prop="standardScore"
            :label="`${$t('评价分')}`"
            width="120"
          ></el-table-column>
          <el-table-column prop="scoringStandar" :label="`${$t('评分标准')}`"></el-table-column>
        </el-table>
        <el-pagination
          class="mt-20px text-right"
          background
          :current-page.sync="page.pageNo"
          @size-change="searchList"
          @current-change="findList"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
          :page-size.sync="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <div slot="footer" class="text-center">
      <el-button
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        :loading="loading"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { SafetyEvaluationIndexApi } from '@wiz-api/safety-evaluation-management'

const Catalog = () => {
  return import('./Catalog')
}
const safetyEvaluationIndexApi = new SafetyEvaluationIndexApi()
export default {
  components: {
    Catalog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    status: {
      type: Number,
      default: 0,
    },
    selectedIds: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      search: {
        project: '',
      },
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      treeId: '',
      selection: [],
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    async findList() {
      this.loading = true
      const [err, res] = await safetyEvaluationIndexApi.getSafetyEvaluationIndexPageList({
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        safetyEvaluationIndexId: this.treeId,
      })
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
      this.loading = false
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    reset() {
      this.search = this.$options.data().search
      this.searchList()
    },
    closeDialog(done) {
      this.selection = []
      this.search = this.$options.data().search
      this.page = this.$options.data().page
      this.total = 0
      this.treeId = ''
      this.$refs.table.clearSelection()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
    handleNodeClick(data) {
      this.treeId = data.id
      this.searchList()
    },
    handleSelectionChange(selection) {
      this.selection = selection
    },
    save() {
      if (this.selection.length === 0) {
        this.$message.warning('请选择无关项')
        return
      }
      this.$emit('save', this.selection)
      this.dialogVisible = false
    },
  },
}
</script>

<style></style>
